import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './paypal_logo.less'

class PayPalLogo extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['color', 'mono']),
  }

  render() {
    return (
      <a
        styleName="paypal-logo-link"
        href="https://www.paypal.com/"
        target="_blank"
      >
        <div styleName={`paypal-logo-${this.props.type}`} />
      </a>
    )
  }
}

export default cssModules(PayPalLogo, styles)
